import React from 'react';
import InsideSalesList from 'pages/InsideSales/InsideSalesList/InsideSalesList';

const InsideSales = () => (
  <InsideSalesList />
);

export default InsideSales;
